import { Injectable } from '@angular/core';

import { ColorService } from '../Services/color';
import { FabricService } from '../Services/fabric';
import { CollectionService } from '../Services/collection';
import { CategoryService } from '../Services/category';
import { SizeService } from '../Services/size';
import { BrandService } from '../Services/brand';

import { Category } from '../Models/category';
import { Color } from '../Models/color';
import { Size } from '../Models/size';
import { Fabric } from '../Models/fabric';
import { Collection } from '../Models/collection';
import { Brand } from '../Models/brand';
import { FilterCategory } from '../Models/filtercategory';


@Injectable()
export class ProductFilterService {

  color: Color[];
  collection: Collection[];
  category: Category[];
  fabric: Fabric[];
  size: Size[];
  brand: Brand[];

  constructor(
    private colorService: ColorService,
    private fabricService: FabricService,
    private sizeService: SizeService,
    private collectionService: CollectionService,
    private categoryService: CategoryService,
    private brandService: BrandService
  ) {
    this.size = new Array<Size>();
    this.getColors();
    this.getFabrics();
    this.getCollections();
    this.getCategories();
    this.getBrands();
  }

  private getColors(): void {
    this.colorService.list()
    .subscribe(data => this.color = data['results'])
  }

  private getFabrics(): void {
    this.fabricService.list()
    .subscribe(data => this.fabric = data['results'])
  }

  private getCollections(): void {
    this.collectionService.list()
    .subscribe(data => this.collection = data['results'])
  }

  /**
   * Categories come in a nested way: a category may hold subs.
   # We need to flatten this structure, for display.
   */
  private getCategories(): void {
    this.categoryService.list()
      .subscribe(
        data =>
          {
            var categories: Array<Category> = [];

            for (var i = 0; i < data['results'].length; i++) {

              categories.push(data['results'][i]);

              if (data['results'][i].subs.length) {

                for (var j = 0; j < data['results'][i].subs.length; j++) {

                  categories.push(data['results'][i].subs[j]);
                }
              }
            }

            this.category = categories;
          }
      )

  }

  //private getSizes(): void {
    //this.sizeService.list()
    //.subscribe(data => this.size = data['results'])
  //}

  public getFilteredSizes(filter: number[]): void {
    this.sizeService.list(filter)
    .subscribe(data => this.size = data['results'])
  }

  private getBrands(): void {
    this.brandService.list()
    .subscribe(data => this.brand = data['results'])
  }

  public getFilterName(filterCategory: string, id: number): string {

    let fc: Array<FilterCategory> = this[filterCategory];

    if (fc) {
      for (let filter of fc) {

        if (filter.id === +id) {
          return filter.name;
        }
      }
    }

    // falling through...
    return "" + id;
  }

  public addVocabValue(key: string, val: number, label: string): void {

    if (!this[key]) {
      this[key] = [];
    }

    this[key].push({'id': val, 'name': label});
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/productfilter.ts